import type { Procedure } from "@medplum/fhirtypes";
import { PROCEDURE_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

export const useProcedureSubscription = createSubscriptionHook<Procedure>("Procedure", PROCEDURE_COLLECTION_NAME);
